import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import type { Source } from "@/mock";

/** Mono uppercase label that sits above a number (design.md eyebrow). */
export function Eyebrow({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn("eyebrow", className)}>{children}</p>;
}

/** Honest, quiet data provenance — "via posthog" / "via matomo". */
export function ProvenanceTag({ source, className }: { source: Source; className?: string }) {
  return (
    <span className={cn("font-mono text-[10px] lowercase tracking-wide text-subtle", className)}>
      via {source}
    </span>
  );
}

/** Rare editorial moment — Newsreader italic (design.md). Use sparingly. */
export function Editorial({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span className={cn("font-serif italic", className)}>{children}</span>
  );
}
